module.exports = __webpack_public_path__ + "static/media/login-img.c04a6766.png";